import axios from 'axios'

export const authApi = axios.create({
  baseURL: process.env.authenticationService,
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
  },
})
